import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

import { useRouter } from 'vue-router/composables';
import { useAppStore } from '@/helpers/composables/useStores';

import { ImpressionTrackingEvents } from '@/enums/events';
import { mrcObservableOptions } from '@/helpers/composables/useBatchImpressionTracking';

import type { SnowplowContext, SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import type { SRClickTitleEvent, SingleTitleSR } from '@/components/sponsored-recommendations/types';

import LazyClientShow from '@/components/LazyClientShow.vue';
import SponsoredRecommendationPoster from '@/components/sponsored-recommendations/SponsoredRecommendationPoster.vue';
import SponsoredRecommendationList from '@/components/sponsored-recommendations/SponsoredRecommendationList.vue';
import SponsoredRecommendationVideo from '@/components/sponsored-recommendations/SponsoredRecommendationVideo.vue';

interface SponsoredRecommendationProps {
	lazy?: boolean;
	fullWidth?: boolean;
	sponsoredAd?: SponsoredAdFragment;
	additionalContexts?: (SnowplowModuleContext | SnowplowContext)[];
}

type SponsoredRecView = 'poster' | 'list' | 'video';

export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendation',
  props: {
    lazy: { type: Boolean, default: true },
    fullWidth: { type: Boolean },
    sponsoredAd: null,
    additionalContexts: { default: () => [] }
  },
  emits: ["onSponsoredRecommendationClick"],
  setup(__props: any) {

const props = __props as { lazy: boolean, fullWidth?: boolean, sponsoredAd?: SponsoredAdFragment, additionalContexts: (SnowplowModuleContext | SnowplowContext)[] }





const { isSeoUser } = useAppStore();
const isMounted = ref(false);
onMounted(() => (isMounted.value = true));

const isSponsoredRecommendationActive = computed(() => props.sponsoredAd?.holdoutGroup === false);
const isRealCampaign = computed(
	() => !['SingleStepSportEvent'].some(type => type === props.sponsoredAd?.campaign?.node.__typename)
);

const campaignNode = computed(() => props.sponsoredAd?.campaign.node as SingleTitleSR);

const impressionTrackingProps = computed(() => {
	const watchNowOffer = props.sponsoredAd?.campaign.watchNowOffer;
	const impressionTrackingLabel = `${campaignNode.value.id}_${watchNowOffer?.package.packageId}`;

	return {
		impressionTrackingLabel,
		impressionTrackingActive: true,
		impressionTrackingProperty: 'ad',
		impressionTrackingValue: props.sponsoredAd?.holdoutGroup ? '0' : '1',
		impressionTrackingObservableOptions: mrcObservableOptions,
		impressionTrackingCategory: ImpressionTrackingEvents.SPONSORED_RECOMMENDATIONS,
	};
});

const sponsoredRecView = computed((): SponsoredRecView | null => {
	const campaign = props.sponsoredAd?.campaign;
	if (!campaign) return null;

	if (campaign.node.__typename === 'GenericTitleList') return 'list';
	if (campaign.promotionalVideo?.url) return 'video';
	return 'poster';
});

const router = useRouter();
function navigateTitle({ title }: SRClickTitleEvent<SingleTitleSR>) {
	const path = title.content.fullPath;
	if (path) router.push({ path });
}

return { __sfc: true,props, isSeoUser, isMounted, isSponsoredRecommendationActive, isRealCampaign, campaignNode, impressionTrackingProps, sponsoredRecView, router, navigateTitle, LazyClientShow, SponsoredRecommendationPoster, SponsoredRecommendationList, SponsoredRecommendationVideo }
}

})